import * as React from 'react'
import IconCrossWhite from '../../icons/ui/IconCrossWhite'
import WarningWhiteIcon from '../../icons/ui/WarningWhite'

interface IEntityErrorMessageProps {
  children?: any
  onCloseBtnClick?: () => void
}

const EntityErrorMessage = (props: IEntityErrorMessageProps) => (
  <div className='flex justify-between items-center col-12 pt1 pb1 bg-orange font-white'>
    <div className='flex items-center ml2'>
      <WarningWhiteIcon className='icon--16x16' />
      <div className='ml1 h5'>{props.children}</div>
    </div>

    <IconCrossWhite className='icon--12x12 mr2 cursor--pointer' onClick={props.onCloseBtnClick} />
  </div>
)

export default EntityErrorMessage



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityErrorMessage.tsx